<matchmaking-form-content [contentImage]="content().mappedImage">
    <matchmaking-form-option-list>
        <div class="options-container">
            @for (option of options(); track $index) {
            <matchmaking-form-option
                data-cy="form-option"
                [option]="option"
                [isSelected]="option.externalId === selectedOption()"
                (setSelected)="setSelected($event)">
            </matchmaking-form-option>

            } @if (showTextField()) {
            <div class="option-text-field">
                <textarea
                    #textAreaElement
                    data-cy="text-area"
                    class="text-area sir-text-style-paragraph-m-default"
                    [placeholder]="translations()!.industry.textareaPlaceholder"
                    [ngModel]="customIndustryText()"
                    (ngModelChange)="setCustomIndustryText($event)">
                </textarea>
            </div>
            }
        </div>
        <matchmaking-form-submit-button
            [text]="translations()!.button.defineProcess"
            class="button-container"
            [isDisabled]="isDisabled()"
            (triggerSubmitEvent)="submit()">
        </matchmaking-form-submit-button>
    </matchmaking-form-option-list>
</matchmaking-form-content>
